export const checkOfferTableColumnsAmount = () => {
    const offerTables = document.querySelectorAll('.offer-table--origin');
    
    if (window.innerWidth < 768) return;
    
    if (offerTables === 'undefined' || offerTables.length < 1) return;

    offerTables.forEach(currentTable => {
        if (!currentTable.classList.contains('offerTableColumnsAmountChecked')) {
            const currentTableColumnsAmount = currentTable.querySelectorAll('.offer-table-header').length;
            
            if (currentTableColumnsAmount == 1) currentTable.classList.add('offer-table--one-column');
            
            if (currentTableColumnsAmount == 2) currentTable.classList.add('offer-table--two-column');
            
            if (currentTableColumnsAmount == 3) currentTable.classList.add('offer-table--three-column');

            currentTable.classList.add('offerTableColumnsAmountChecked');
        }
    });
}